import { render, staticRenderFns } from "./UpsertBuildingModal.vue?vue&type=template&id=30a5b7e9&"
import script from "./UpsertBuildingModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertBuildingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports